import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { CASTFile } from 'types/models/CASTFile';

type ScanInProgressState = {
  scanInProgressList: CASTFile[];
  addFileToScanInProgressList: (file: CASTFile) => void;
  isFileScanInProgress: (file: CASTFile) => boolean;
  removeFileFromScanInProgressList: (file: CASTFile) => void;
};

// Function to check if two files are equal
function filesAreEqual(file1: CASTFile, file2: CASTFile) {
  if (file1.id && file2.id) return file1.id === file2.id;
  return file1.fileName === file2.fileName && file1.bucketLocation === file2.bucketLocation;
}

const useScanInProgressStore = create<ScanInProgressState>()(
  persist(
    (set, get) => ({
      scanInProgressList: [],

      addFileToScanInProgressList: (file: CASTFile) => {
        const scanInProgressList = [...get().scanInProgressList, file];
        set({ scanInProgressList });
      },

      isFileScanInProgress: (file: CASTFile) => {
        return get().scanInProgressList.some((f) => filesAreEqual(f, file));
      },

      removeFileFromScanInProgressList: (file: CASTFile) => {
        const scanInProgressList = get().scanInProgressList.filter((f) => !filesAreEqual(f, file));
        set({ scanInProgressList });
      },
    }),
    {
      name: 'scanInProgressList',
      storage: createJSONStorage(() => sessionStorage),
      partialize: (state) => ({ uploadingFileList: state.scanInProgressList }),
    }
  )
);

export default useScanInProgressStore;
